// Pages/NotFoundPage.jsx
import React from "react";
import { useNavigate } from "react-router-dom";

export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="text-center">
        <h1 className="text-8xl font-bold text-emerald-600 mb-4">404</h1>
        <h2 className="text-2xl font-semibold text-gray-800 mb-2">
          Página não encontrada
        </h2>
        <p className="text-gray-500 mb-6">
          A página que você procura não existe.
        </p>
        <button
          onClick={() => navigate("/")}
          className="px-6 py-2 bg-emerald-600 hover:bg-emerald-700 text-white rounded-lg transition-colors"
        >
          Voltar ao início
        </button>
      </div>
    </div>
  );
}